<template>
  <el-dialog top="30vh" class="logout-dialog" :visible.sync="isLiveLogout" center :before-close="closeDialog" width="30%">
    <div class="dia-content">
					<span>退出登录会在5分钟后结束直播</span>
		</div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" round @click="toggleLiveLogout(false)">取 消</el-button>
      <el-button class="commit" round type="primary" @click="logout()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../util/http";
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState(["isLiveLogout"]),
  },

  methods: {
    ...mapMutations(["changeUserInfo", "toggleLiveLogout"]),
    async logout() {
      const {
        data: { status },
      } = await post({
        url: "/api/user/logout",
      });
      if (status == 0) {
        localStorage.clear();
        this.changeUserInfo({ id: "", diamond: 0, gold: 0 });
        // setTimeout(() => {
        //   this.endLive();
        // }, 5000);
        location.reload();
      }
    },
    closeDialog() {
      this.toggleLiveLogout(false);
    },
    async endLive() {
      try {
        const {
          data: { status },
        } = await post({ url: "/webapi/live/endLive" });
        if (status == 0) {
          this.$router.push("/");
        }
      } catch (e) {
        console.log("退出直播出错", e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
	.logout-dialog{
		::v-deep .el-dialog__header{
			display : none;
		}
		.dia-content{
			padding : .2rem .2rem;
			padding-top : .3rem;
			color : #333333;
			font-size : .18rem;
			display : flex;
			justify-content: center;
			align-items: center;
		}
		.cancel,.cancel:hover{
			border-color: #02A8A2;
			color : #02A8A2;
			padding: .1rem .45rem;
		}
		.commit,.commit:hover{
			background-color: #02A8A2;
			color : #ffffff;
			border-color: #02A8A2;
			padding: .1rem .45rem;
		}
	}
</style>
